/**
 * For calls whose failure means nothing where they are made, such as a peer that has closed, storage that is full, or
 * text that is not JSON: `attempt` answers undefined where `fn` throws, `quietly` is the handler for a promise whose
 * failure is ignored, and `noop` is a callback that does nothing. Each makes the choice visible where an empty catch
 * block would hide it, which the linter refuses.
 */
export function attempt<T>(fn: () => T): T | undefined {
  try {
    return fn();
  } catch {
    return undefined;
  }
}

export const quietly = (): undefined => undefined;

export const noop = (): void => undefined;
